import React, { useState, useContext, useEffect } from "react";

import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

import loaderData from "../../assets/loader.json";
import BackArrow from "../../atoms/backArrow/backArrow";
import rightArrow from "../../assets/images/right_caret.svg";
import FloatingInput from "../../atoms/floatingInput/floatingInput";
import LoaderLight from "../../atoms/loaderLight/loaderLight";
import searchIcon from "../../assets/testRide/search-white.svg";
import graySearchIcon from "../../assets/testRide/gray-search.svg";
import { setCookie, getCookie } from "../../utils/utils";
import { makeAPICall, MultipleAPICalls } from "../../services/apiService";

import "./exchange.scss";

const SearchExchange = () => {
  const history = useHistory();
  const [orderIdText, setOrderIdText] = useState("");
  const [idInputClass, setIdInputClass] = useState("");
  const [orderIdTxtValid, setOrderIdTxtValid] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [ordersList, setOrdersList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [ineligibleOrders, setIneligibleOrders] = useState([])
  const [ineligibleMessage, setIneligibleOrderMsg] = useState("No exchange offer available on this order")
  const [showToast, setShowToast] = useState('none');
  const [toastMessage, setToastMessage] = useState('');

  const orderIdTextChange = (e) => {
    if (e.target.value) {
      if (e.target.value.length === 6) {
        setOrderIdTxtValid(true);
      } else {
        setIdInputClass("input-green");
        setShowErrorMsg(false);
        setOrderIdTxtValid(false);
      }
      setOrderIdText((e.target.value).toLocaleUpperCase());
    } else {
      setOrderIdTxtValid(false);
      setOrderIdText("");
      setIdInputClass("");
      setOrdersList([]);
    }
  };

  const orderIdFocus = () => {
    setIdInputClass("input-green");
  };

  const orderIdBlur = () => {
    setIdInputClass("");
  };

  const searchById = () => {
    setOrdersList([])
    if(orderIdText.length !== 6) {
      return
    }
    setLoader(true);

    let config = {
      method: "get",
      url: `api/exchange/getExchangeOrders`,
      params: {
        last6digits: orderIdText,
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data.status === "SUCCESSFUL") {
          if (resp.data.data.length !== 0) {
            getUpdatedOrderList(resp.data.data)
            // setOrdersList(resp.data.data);
          } else {
            setShowErrorMsg(true);
            setOrdersList([]);
            setIdInputClass("input-error");
          }
        }
        setLoader(false);
      })
      .catch((err) => {
        setShowErrorMsg(true);
        setIdInputClass("input-error");
        setLoader(false);
      });
  };

  const checkValidExchange = (order) => {
    if(ineligibleOrders.includes(order.order_id)) {
      return;
    }
    setLoader(true);

    let config = {
      method: "get",
      url: `api/exchange/getExchangeOrderDetail`,
      params: {
        ...order
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data.status === "SUCCESSFUL") {
          console.log("success")
        }
        setLoader(false);
        history.push({
          pathname: `/scooter-exchange-data`,
          state: {
            ...order
          }
        })
      })
      .catch((err) => {
        setIneligibleOrders([...ineligibleOrders, order.order_id])
        setIneligibleOrderMsg(err?.response?.data?.data?.message || ineligibleMessage)
        setLoader(false);
      });
  }

  const getOrderAction = (order) => {
    setLoader(true);

    let config = {
      method: "get",
      url: `api/exchange/getOrderAction`,
      params: {
        ...order,
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data.status === "SUCCESSFUL") {
          console.log("success")
        }
        setLoader(false);
        handleOrder(resp.data?.data)
      })
      .catch((err) => {
        setLoader(false);
      });
  }

  const handleOrder = (order) => {
    if (order?.action == "CREATE_NEW" ) {
      history.push({
        pathname: `/scooter-exchange-edit`,
        state: {
          ...order
        }
      })
    } else if (order?.action == "EXCHANGE_SOFT_REJECTED") {
      history.push({
        pathname: `/scooter-exchange-online-edit`,
        state: {
          ...order
        }
      })
    } else if (order?.action == "VIEW_EDIT") {
      history.push({
        pathname: `/scooter-exchange-data`,
        state: {
          ...order
        }
      })
    } else if (order?.action == "EXCHANGE_COMPLETED") {
      history.push({
        pathname: `/scooter-exchange-data`,
        state: {
          ...order
        }
      })
    }  else if (order?.action == "VERIFY_EXCHANGE") {
      history.push({
        pathname: `/scooter-exchange-verify`,
        state: {
          ...order
        }
      })
    } else if (order?.action == "EXCHANGE_NOT_APPLICABLE") {
      setToastMessage("No exchange offer available on this order");
      setShowToast('block');
      setTimeout(() => {
        setShowToast('none');
      }, 1000);
      setIneligibleOrders([...ineligibleOrders, order.order_id])
    }
  }

  const getUpdatedOrderList = (orders) => {
    let config = {} , ordersConfig = [], ordersList = []
    orders.forEach((order) => {
      config = {
        method: "get",
        url: `api/exchange/getOrderAction`,
        params: {
          ...order,
        },
      };
      ordersConfig.push(config)
    })

    MultipleAPICalls(ordersConfig).then((response) => {
      if (response) {
        ordersList = response.map((item) => item?.data?.data)
        setOrdersList(ordersList)
      }
    })
  }

  const handleStatusColor = (order) => {
    if (order?.action == "CREATE_NEW") {
      return "grey-text-title"
    } else if (order?.action == "VIEW_EDIT") {
      return "black-text"
    } else if (order?.action == "EXCHANGE_COMPLETED") {
      return "green-text"
    }  else if (order?.action == "VERIFY_EXCHANGE" || order?.action == "EXCHANGE_SOFT_REJECTED") {
      return "orange-text"
    } else if (order?.action == "EXCHANGE_NOT_APPLICABLE") {
      return "red-text"
    }
  }

  let bcUserDetails = JSON.parse(localStorage.getItem("bcUserDetails") || "{}");
  return (
    <div className="loan-container">
      <div>
        <div className="backArrow">
          <Link to="/booking-list">
            <BackArrow removeClass={true} />
          </Link>
        </div>
        <div className="header-text">Scooter exchange</div>
      </div>
      <div className="inner-container">
        <div className="form-container">
          <div className="loan-inputfield">
            <FloatingInput
              id="orderId"
              name="orderId"
              type="text"
              labelName="Enter last 6 digits of order ID"
              inputValue={orderIdText}
              onChange={orderIdTextChange}
              className={`card-number ${idInputClass}`}
              placeholder="Order ID"
              onFocus={orderIdFocus}
              onBlur={orderIdBlur}
              maxLength={6}
              labelStyles={{ color: showErrorMsg ? "#D44C59" : "" }}
            />
            {showErrorMsg && (
              <div className="error-msg-container">
                <span className="error-msg-text">Invalid order ID</span>
              </div>
            )}
          </div>
          {/* {loader ? (
            <button className={`search-disable-button`}>
              <div className="loader-container-np">
                <LoaderLight
                  loaderData={loaderData}
                  loaderStyle="loader-light-np"
                />
              </div>{" "}
            </button>
          ) : ( */
            <button
              className={
                orderIdTxtValid ? "search-button" : "search-disable-button"
              }
              type="submit"
              onClick={() => searchById()}
            >
              <img src={searchIcon} alt="searchIcon" />
            </button>
          }
        </div>
        {ordersList.length == 0 ? (
          <div className="no-orders">
            <div
              style={{
                width: 180,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <img
                src={graySearchIcon}
                alt="searchIcon"
                style={{ height: 60, width: 60 }}
              />
              <p>Enter last 6 digits of order ID to search</p>
            </div>
          </div>
        ) : (
          <div>
            {ordersList.map((order) => (
              <div
                className="orderlist-container"
                onClick={() => {
                  handleOrder(order)
                  // getOrderAction(order)
                  // handleOrder(order)
                }}
              >
                <div>
                  <div className="order-number">{order.order_id}</div>
                  <div className="user-name">{order.name}</div>
                  <div className={handleStatusColor(order)}>{order?.message}</div>
                  {/* {ineligibleOrders.includes(order.order_id) && (
                    <div className="red-text">{ineligibleMessage}</div>
                  )} */}
                </div>
                <img
                  src={rightArrow}
                  alt="rightArrow"
                  style={{ height: 30, width: 30 }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="toastWrapper">
          <div style={{ display: showToast }} className="toastContainer">
            {toastMessage}
          </div>
        </div>
    </div>
  );
};

export default SearchExchange;
